import { UserResponse } from './user-response';

export class UsersResponse {
  data: UserResponse[] = [];
  totalCount = 0;
}
